import React, { useRef, useState } from 'react';
import { Loader, Dimmer, } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';

import { Mensaje, MensajeSiNo } from '../mensajes';

export const ImagenAnticipo = (props) => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const organizacion = JSON.parse(sessionStorage.getItem("riforganizacion"));


  const btnCancela = useRef();
  const btnSalir = useRef();
  const btnAcepta = useRef();

  const [pathImage, setPathImage] = useState({
    imagen: `${op.conexion}/imagen?img=subir.png`,
  });
  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });


  const blanquear = () => {
    setPathImage('...');
  }

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();

  };


  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });

  };

  const cerrarModal = () => {
    if (props.llamado === 2) {
      props.onHideCancelar();
    }
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
  }

  const getDescargar = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/imagen?img=${organizacion}/imagenesanticipo/${props.imagenanticipo.trim()}`;
    axios
      .get(endpoint, {
        responseType: "arraybuffer",
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${props.imagen.trim()}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => setActivate(false));
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    getDescargar();
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {

        setPathImage({
          imagen: `${op.conexion
            }/imagen?img=${organizacion}/imagenesanticipo/${props.imagenanticipo.trim()}`,
        });

      }}
    >
      <Modal.Header className='azulGradiant2 header-modal'>
        <div className='fw-bold' style={{ color: "#fff" }}><h3>Imagen Anticipo</h3></div>

        <a href='#' ref={btnSalir} onClick={cancelar} className='text-light' ><i className="fas fa-times fa-1x shadow" > {/* Salir */}</i></a>

      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ?
              cerrarModal() :
              setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
          } />
        <MensajeSiNo mensaje={mensajesino}
          onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className='col-md-12 mx-auto px-0 d-flex justify-content-center'>

          <img src={pathImage.imagen} style={{ height: '750px' }} className="img-fluid img-thumbnail" alt="..." />

        </div>
      </Modal.Body >
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">

          <div className='col-md-4 ml-auto px-0 m-0 d-flex justify-content-end'>
            <button ref={btnAcepta} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-primary mx-1"><i className="fas fa-download">  Descargar</i></button>
            <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill mx-1"><i className="fas fa-window-close"> Cancelar</i></button>
          </div>
        </div>

      </Modal.Footer>

    </Modal >
  );
}




// WEBPACK FOOTER //
// ./src/components/finanzas/modalImagenAnticipo.js